import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import classes from '../../../common/tabs/index.module.scss'
import { GRAPH_TYPE } from '../../constant'

const Tab = ({ activeTab, handleChangeTab, tabClassName }) => {
  const items = [
    {
      key: GRAPH_TYPE.RADIAL_MAP,
      label: 'connectMap.entityMap.RADIAL_MAP',
    },
    {
      key: GRAPH_TYPE.LEGAL_BENEFICIAL,
      label: 'connectMap.entityMap.LEGAL_BENEFICIAL',
    },
    {
      key: GRAPH_TYPE.INVESTEE_MAP,
      label: 'connectMap.entityMap.INVESTEE_MAP',
    },
  ]

  return (
    <Element className={`${classes.tabs} ${tabClassName}`}>
      <Element className={classes.tabList} style={{ color: '#3A414B' }}>
        {items.map((item, index) => (
          <Element
            key={item.key}
            className={`${classes.tabItem} ${
              item.key === activeTab ? classes.active : ''
            }`}
            style={{
              color: item.key === activeTab ? '#2C73E8' : '',
              borderColor: '#2C73E8',
            }}
            onClick={() => handleChangeTab(item.key)}
          >
            <Translate value={item.label} />
          </Element>
        ))}
      </Element>
    </Element>
  )
}

export default Tab
